import React from "react";
import { useTranslation } from "react-i18next";

const useSfdaTableColumns = () => {
  const { t } = useTranslation();

  const columns = [
    {
      header: t("SGC Code"),
      field: "supergitMasterCode",
      render: (row) => (
        <span className="font-semibold text-[#0070C2]">
          {row.supergitMasterCode || "—"}
        </span>
      ),
    },
    {
      header: t("Trade Name"),
      field: "tradeName",
      render: (row) => (
        <span className="font-medium">{row.tradeName || "—"}</span>
      ),
    },
    {
      header: t("Scientific Name"),
      field: "scientificName",
      cellSx: { whiteSpace: "normal", minWidth: 250, maxWidth: 350 },
      render: (row) => (
        <span className="text-gray-600 text-[11px] whitespace-pre-wrap break-words block leading-snug">
          {row.scientificName || "—"}
        </span>
      ),
    },
    {
      header: t("Register No."),
      field: "registerNumber",
    },
    {
      header: t("Strength"),
      render: (row) => {
        const strength = row.strength || "";
        const unit = row.strengthUnit || "";
        return strength ? `${strength} ${unit}`.trim() : "—";
      },
    },
    {
      header: t("Form"),
      field: "pharmaceuticalForm",
      render: (row) => row.pharmaceuticalForm || "—",
    },
    {
      header: t("Route"),
      field: "administrationRoute",
      render: (row) => row.administrationRoute || "—",
    },
    {
      header: t("Price"),
      field: "publicPrice",
      render: (row) =>
        row.publicPrice ? (
          <span className="font-medium">{row.publicPrice} SAR</span>
        ) : (
          "—"
        ),
    },
    {
      header: t("Marketing Co."),
      field: "marketingCompany",
      render: (row) => (
        <span className="text-[11px]">{row.marketingCompany || "—"}</span>
      ),
    },
  ];

  return columns;
};

export default useSfdaTableColumns;
